module.exports = __webpack_public_path__ + "img/framework.37078c5c.png";